// extracted by mini-css-extract-plugin
export var cartContainer = "_lv-4";
export var gray = "_lv-1";
export var itemContainer = "_lv-2";
export var itemDetails = "_lv-3";
export var strong = "_lv-0";